<template>
  <div class="asd-form">
    <div class="section-title">
      <h6>
        <i class="fas fa-angle-double-right"></i>
        Historie změn vlastnosti {{ value.name }}
      </h6>
      <div class="section-title-controls">
        <span>
          <button v-help.mouse="`Zobrazit/Skrýt celou historii`"
                  class="asd-btn-edit"
                  @click="showAll = !showAll"
          >
            <i class="fas fa-eye"></i>
          </button>
        </span>
      </div>
    </div>

    <table class="asd-table">
      <thead>
        <tr class="table-heading">
          <th>uživatel</th>
          <th>datum</th>
          <th>ze stavu</th>
          <th>do stavu</th>
          <th>komentář</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="row in data"
            :key="row.id"
        >
          <td>{{ row.username }}</td>
          <td>{{ row.date | formatTimestamp }}</td>
          <td v-if="row.from"
              :style="{'color': row.from.color}"
          >
            {{ row.from.label }}
          </td>
          <td v-else
              style="font-style: italic"
          >
            chybi ze stavu
          </td>
          <td v-if="row.to"
              :style="{'color': row.to.color}"
          >
            {{ row.to.label }}
          </td>
          <td v-else
              style="font-style: italic"
          >
            chybi do stavu
          </td>
          <td>
            <pre v-text="row.comment"></pre>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="showAll == false"
         class="alert alert-warning"
    >
      Jsou zobrazeny pouze 3 nejnovější záznamy.
    </div>
  </div>
</template>

<script>
import { map, set, get, sortBy, slice } from 'lodash'

export default {
    name: 'StateHistory',
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showAll: false,
        }
    },
    computed: {
        data() {
            let d = map(this.value.history, row => {
                const username = get(this.$store.getters.userById(row.user), 'username')
                set(row, 'username', username)
                return row
            })
            d = sortBy(d, i => -i.date)
            d = slice(d, 0, this.showAll ? 99999 : 3)
            return d
        },
    },
}
</script>

<style scoped>

</style>

